import { AgenticFlowByline } from '@agentic-flow-studio/shared/components/agentic-flow-byline';
import { completeOAuthBridge } from '@agentic-flow-studio/shared/lib/betterAuthClient';
import { Loader2, Truck } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Landing point for Google sign-in. Persists the OAuth bridge's bearer session before
 * continuing to the requested Job Plan route.
 */
export default function OAuthComplete() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const result = completeOAuthBridge('job-plan');
    if (result.success) {
      navigate(searchParams.get('redirect') || '/dashboard', { replace: true });
    } else {
      setError(result.error || 'Google sign-in failed. Please try again.');
    }
  }, [navigate, searchParams]);

  return (
    <main className="min-h-screen flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center gap-8 p-6">
        <div className="flex items-center gap-2 text-lg font-semibold">
          <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center text-primary-foreground">
            <Truck className="h-5 w-5" />
          </div>
          Job Plan
        </div>
        {error ? (
          <div className="text-center space-y-4">
            <p className="text-sm text-destructive">{error}</p>
            <button
              onClick={() => navigate('/login')}
              className="text-sm font-medium text-primary hover:underline"
            >
              Back to login
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-3">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <p className="text-sm text-muted-foreground">Finishing sign-in...</p>
          </div>
        )}
        <AgenticFlowByline />
      </div>
    </main>
  );
}
